import { render, staticRenderFns } from "./LayoutOverflow.vue?vue&type=template&id=c542ac5c&"
import script from "./LayoutOverflow.vue?vue&type=script&lang=js&"
export * from "./LayoutOverflow.vue?vue&type=script&lang=js&"
import style0 from "./LayoutOverflow.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports